import { pageHead } from "@/lib/routeHead";
import { createFileRoute } from "@tanstack/react-router";
import CrossModuleReportPage from "@/pages/admin/CrossModuleReportPage";

export const Route = createFileRoute("/_admin/admin/cross-module-report")({
  head: () => pageHead("Admin · Cross Module Report", "AKIVA admin · cross module report portal.", "/admin/cross-module-report", true),
  component: CrossModuleReportPage,
});
